/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Create_TitleInputs */

const en_settings_overview_create_title = /** @type {(inputs: Settings_Overview_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make your next rap video`)
};

/**
* | output |
* | --- |
* | "Make your next rap video" |
*
* @param {Settings_Overview_Create_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_overview_create_title = /** @type {((inputs?: Settings_Overview_Create_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Create_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_overview_create_title(inputs)
});
export { settings_overview_create_title as "settings.overview.create_title" }